/**
 * 公車資料來源（前端，與 backend/utils/bus-data-provenance.js 同步）
 */
export const PROVIDERS = {
    MOTC_TDX: { id: 'MOTC_TDX', label_zh: '交通部運輸資料流通平台（TDX）' },
    TAIPEI_CITY: { id: 'TAIPEI_CITY', label_zh: '臺北市政府公車資訊系統' },
    NEW_TAIPEI_CITY: { id: 'NEW_TAIPEI_CITY', label_zh: '新北市政府公車資訊系統' }
};

export function provenanceSummaryZh(provenance) {
    if (!provenance?.labels_zh?.length) return '交通部 TDX';
    return provenance.labels_zh.join('、');
}

export function routeRoleLabel(role) {
    const map = {
        display: '顯示用主線',
        primary: '主線',
        variant: '營運支線'
    };
    return map[role] || role || '路線';
}
